export default [
    { key: 'en-US', value: 'English' },
    { key: 'en-XA', value: 'Éñϱℓïƨλ (Þƨèúδô-Âççèñƭƨ)' },
];
